import React, { useEffect } from "react"; 
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SplashPage from "./pages/splash-page";
import ServiceDetailsPage from "./pages/service-details";
import HelpPage from "./pages/help-page";
import MobileVerifyPage from "./pages/mobile-verify-page";
import MobileOtpPage from "./pages/mobile-otp-page";
import MainPage from "./pages/main-page";
import TimesPage from "./pages/times-page";
import ThemeColorHandler from "./core/ThemeColorHandler";
import ServiceList from "./pages/Service-List";
import DresserList from "./pages/Dresser-List";
import Profile from "./pages/Profile";
import InfoPage from "./pages/InfoPage";
import Transactions from "./components/Profile/transactions/transactions";
import BookingHistory from "./components/Profile/BookingHistory/BookingHistory";
import PaymentSuccess from "./pages/payment-success";
import PaymentFailed from "./pages/PaymentFailed";
import Payment from "./pages/payment";
import { AppConsts } from "./core/AppConsts";
import Clarity from "@microsoft/clarity";
import { Crisp } from "crisp-sdk-web";
import Layout from "./components/Layout/Layout";
import UpdateModal from "./UpdateModal";
// اگر نیاز به کنترل نصب، چرخش و جلوگیری از بازگشت داشتید می‌توانید این‌ها را فعال کنید
// import PortraitHandler from "./core/PortraitHandler";
// import InstallerHandler from "./core/InstallerHandler";
// import BlockNavigationHandler from "./core/BlockNavigationHandler";

const App: React.FC = () => {
  useEffect(() => {
    // شناسایی iOS و اضافه کردن کلاس
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.userAgent.includes("Macintosh") && "ontouchend" in document);
    if (isIOS) {
      document.body.classList.add('ios-device');
    }
  }, []);

  
  Clarity.init(AppConsts.projectId);
  

  // راه‌اندازی Crisp Chat
  Crisp.configure(AppConsts.CRISP_WEBSITE_ID, { autoload: false });
  Crisp.load();

  
  return (
    <Router>
      {/* <PortraitHandler /> */}
      {/* <InstallerHandler /> */}
      {/* <BlockNavigationHandler /> */}
      <ThemeColorHandler />
      <Layout>
      {/*<UpdateModal />*/}
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/mobile-verify" element={<MobileVerifyPage />} />
        <Route path="/verify-otp" element={<MobileOtpPage />} />
        <Route path="/main" element={<MainPage />} />
        <Route path="/times" element={<TimesPage />} />
        <Route path="/service-details" element={<ServiceDetailsPage />} />
        <Route path="/ServiceList" element={<ServiceList />} />
        <Route path="/DresserList" element={<DresserList />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/profile/info" element={<InfoPage />} />
        <Route path="/profile/transactions" element={<Transactions />} />
        <Route path="/profile/BookingHistory" element={<BookingHistory />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/PaymentFailed" element={<PaymentFailed />} />
        <Route path="/payment" element={<Payment />} />
      </Routes>
      </Layout>
    </Router>
  );
};

export default App;
